export default __webpack_public_path__ + "static/cat-logo-31bf959272e48871e171512b76f5b1d1.png";